import { DeviceUtil, GeometryUtil } from "./control.util"
import { Constant } from "./layout.constant"

class LayoutElement {
    static ELEMENT_LINE = 'line'
    static ELEMENT_TEXT = 'text'
    static ELEMENT_IMAGE = 'image'
    static ELEMENT_BARCODE = 'barcode'
    static ELEMENT_QRCODE = 'qrcode'
    static ELEMENT_LIST = 'list'

    static defaultTemplet() {
        return {
            paperType: 'custom',
            width: 210,
            height: 297,
            version: 0,
            name: '新建模版',
            direction: '0',
            bgimg: { base64: undefined, img: undefined },
            bgshow: false,
            children: [],
            offsetX: 0,
            offsetY: 0,
            copies: 1,
        }
    }

    static defaultLineElement(type) {
        const ele = {
            cls: this.ELEMENT_LINE,
            color: '#000000',
            type: type,
            weight: 1,
        }
        return Object.assign(this.defaultBaseElement(), ele)
    }

    static defaultTextElement() {
        const ele = {
            cls: LayoutElement.ELEMENT_TEXT,
            color: '#000000',
            font: 'SimSun',
            text: '文本',
            italic: false,
            bold: false,
            overflow: false,//溢出缩放
            size: 16,
            align: 'left',
            vertical: 'middle',
            type: '0',//文本类型：0表达式1变量2文本
        }
        return Object.assign(this.defaultBaseElement(), ele)
    }

    static defaultImageElement() {
        const ele = {
            cls: this.ELEMENT_IMAGE,
            code: ""
        }
        return Object.assign(this.defaultBaseElement(), ele)
    }

    static defaultBarcodeElement() {
        const ele = {
            cls: this.ELEMENT_BARCODE,
            code: "",
            type: '0',//文本类型：0固定值1变量编码
        }
        return Object.assign(this.defaultBaseElement(), ele)
    }

    static defaultQrcodeElement() {
        const ele = {
            cls: this.ELEMENT_QRCODE,
            code: "",
            type: '0',//文本类型：0固定值1变量编码
        }
        return Object.assign(this.defaultBaseElement(), ele)
    }

    static defaultListElement() {
        const ele = {
            cls: this.ELEMENT_LIST,
            cols: [],//列属性集合
            rows: [],//行数据
            border: true,//弃用
            borderWeight: 1,//边框宽度
            borderColor: '#000',//边框颜色
            title: true,//是否显示表头
            titleHeight: 10,//表头高度
            titleTop: true,//表头边框
            titleLeft: true,
            titleRight: true,
            titleBottom: true,
            titleInside: true,
            rowdata: "",//内容数据变量
            rowfill: false,//分页补全
            rowHeight: 10,//内容行高
            rowTop: true,//内容边框
            rowLeft: true,
            rowRight: true,
            rowBottom: true,
            rowInsideV: true,
            rowInsideH: true,
            footer: false,//是否显示表尾
            footerHeight: 10,
            footerTop: true,
            footerLeft: true,
            footerRight: true,
            footerBottom: true,
            footerInside: true,


        }
        return Object.assign(this.defaultBaseElement(), ele)
    }

    static defaultListColElement() {
        return {
            field: "",
            title: "",
            display: "text",
            font: "SimSun",
            size: 16,
            bold: false,
            italic: false,
            align: "left",
            vertical: 'middle',
            color: "#000000",
            width: 20,
            padding: 3,
            //表尾添加
            footerText: "",
            footerColspan: 1,
        }
    }

    static defaultBaseElement() {
        return {
            cls: "null",
            ax1: 0,
            ax2: 0,
            ay1: 0,
            ay2: 0,
        }
    }


    static hitLineDragType(point, element) {
        if (this.#hitDragPoint(point, element.ax1, element.ay1)) {
            return 1
        } else if (this.#hitDragPoint(point, element.ax2, element.ay2)) {
            return 3
        } else if (GeometryUtil.pointToLineDistance(point.offsetX, point.offsetY, element.ax1, element.ay1, element.ax2, element.ay2) < Constant.POINT_SELECT_DISTANCE) {
            return 0
        } else {
            return -1
        }
    }

    static hitRectDragType(point, element) {
        if (this.#hitDragPoint(point, element.ax1, element.ay1)) {
            return 1
        } else if (this.#hitDragPoint(point, element.ax2, element.ay1)) {
            return 2
        } else if (this.#hitDragPoint(point, element.ax2, element.ay2)) {
            return 3
        } else if (this.#hitDragPoint(point, element.ax1, element.ay2)) {
            return 4
        } else if (GeometryUtil.pointInRect(point.offsetX, point.offsetY, element.ax1, element.ay1, element.ax2, element.ay2)) {
            return 0
        } else {
            return -1
        }
    }

    static contactLineElement(point1, point2, element) {
        if (GeometryUtil.pointInRect(element.ax1, element.ay1, point1.offsetX, point1.offsetY, point2.offsetX, point2.offsetY)) {
            return true
        } else if (GeometryUtil.pointInRect(element.ax2, element.ay2, point1.offsetX, point1.offsetY, point2.offsetX, point2.offsetY)) {
            return true
        } else {
            return false
        }
    }

    static contactRectElement(point1, point2, element) {
        if (GeometryUtil.pointInRect(element.ax1, element.ay1, point1.offsetX, point1.offsetY, point2.offsetX, point2.offsetY)) {
            return true
        } else if (GeometryUtil.pointInRect(element.ax1, element.ay2, point1.offsetX, point1.offsetY, point2.offsetX, point2.offsetY)) {
            return true
        } else if (GeometryUtil.pointInRect(element.ax1, element.ay1, point1.offsetX, point1.offsetY, point2.offsetX, point2.offsetY)) {
            return true
        } else if (GeometryUtil.pointInRect(element.ax2, element.ay1, point1.offsetX, point1.offsetY, point2.offsetX, point2.offsetY)) {
            return true
        } else {
            return false
        }
    }


    static #hitDragPoint(point, ax, ay) {
        const len = Constant.POINT_WIDTH
        return GeometryUtil.pointInRect(point.offsetX, point.offsetY, ax - len, ay - len, ax + len, ay + len)
    }


}

export {
    LayoutElement
}